import { Trophy, Goal, Medal, Shield, Footprints } from "lucide-react";
import { Reveal } from "./Reveal";

const ITEMS = [
  { icon: Trophy, titulo: "Escola de Futebol", detalhe: "De 4 a 17 anos" },
  { icon: Goal, titulo: "Campo Society", detalhe: "Estrutura completa e iluminada" },
  { icon: Medal, titulo: "Alto Rendimento", detalhe: "Preparação para clubes" },
  { icon: Shield, titulo: "Treino de Goleiro", detalhe: "Escola específica" },
  { icon: Footprints, titulo: "Turmas Iniciantes", detalhe: "Primeiros passos no futebol" },
];

const Highlights = () => (
  <section data-testid="highlights-strip" className="relative bg-night py-14">
    <div className="mx-auto max-w-7xl px-4 sm:px-6 lg:px-8">
      <div className="grid grid-cols-2 gap-4 sm:grid-cols-3 lg:grid-cols-5">
        {ITEMS.map((item, i) => (
          <Reveal key={item.titulo} delay={i * 0.08}>
            <div
              data-testid={`highlight-card-${i}`}
              className="group h-full rounded-2xl border border-white/10 bg-navy/60 p-5 transition-all duration-300 hover:-translate-y-1.5 hover:border-lawn/50 hover:bg-navy"
            >
              <item.icon
                size={30}
                strokeWidth={1.8}
                className="mb-3 text-lawn transition-transform duration-300 group-hover:scale-110"
              />
              <p className="font-heading text-sm font-semibold uppercase tracking-wide text-white">
                {item.titulo}
              </p>
              <p className="mt-1 text-xs text-white/60">{item.detalhe}</p>
            </div>
          </Reveal>
        ))}
      </div>
    </div>
  </section>
);

export default Highlights;
